import {generalConstants} from '../../constants'
import {userActions} from "../user/actions";
import {appHelp} from '../../helpers'
export const generalAuthActions = {
    coreCredentialsInit,
    resetCredentials,
    updateCarmelUserCredentials
};


export function coreCredentialsInit(accessToken = null) {
    const accessTokenCookie = appHelp.getCookie('access_token');
    console.log('accessTokenCookie ', accessTokenCookie);

    const Credentials = {
        "accessToken": accessToken || accessTokenCookie || generalConstants.CARMEL_API_KEY,
        "appData": {
            "appSourceType": "D",
            "deviceAlertId": "",
            "osVersion": "Win32",
            "platform": "W",
            "timeout": 10000,
            "timeoutCode": "N"
        },
    };

    return {
        type: generalConstants.CORE_CREDENTIALS_INIT,
        Credentials
    }
}

function resetCredentials() {
    return dispatch => {
        dispatch(coreCredentialsInit());
        dispatch(reset())
    };

    function reset() {
        return {
            type: generalConstants.RESET_CREDENTIALS
        }
    }


}

function updateCarmelUserCredentials(accessToken, authType = "C") {
    return dispatch => {
        try {
            const now = Date.now();
            let accessTokenValue = null;
            if(accessToken) {
                accessTokenValue = accessToken.access_token;
                const expireAccessTokenTime = new Date(now + (accessToken.expires_in * 1000)); // access token expiration date from server
                const expireRefreshTokenTime = new Date();
                expireRefreshTokenTime.setMonth(expireRefreshTokenTime.getMonth() + 6);
                const secureCookie = window.location.protocol === 'https:' ? ';secure' : '';

                document.cookie = `access_token=${accessTokenValue};expires=${expireAccessTokenTime.toUTCString()};path=/${secureCookie}`;
                document.cookie = `refresh_token=${accessToken.refresh_token};expires=${expireRefreshTokenTime.toUTCString()};path=/${secureCookie}`;
            }

            if (accessTokenValue) {
                // Hydrate CoreCredentials from the token response; cookies can lag or be unavailable on local HTTP.
                dispatch(coreCredentialsInit(accessTokenValue));
            }
            const CredentialsUpdate = {
                // Can be "C" for Carmel user, "F" for Facebook User or "G" For Guest User
                // Put Hard Coded "C" because it's a dedicated action.
                "custAuthType": authType,

                // "accessToken": accessToken,
                // "custPassword": LoginPassword
            };
            dispatch(update(CredentialsUpdate))
        } catch (e) {
            console.log(e);
            dispatch(userActions.logout(true))
        }
    };


    function update(CredentialsUpdate) {
        return {
            type: generalConstants.CREDENTIALS_UPDATE,
            CredentialsUpdate,
        }
    }
}